export default __webpack_public_path__ + "static/media/031-saving.948eecfe.svg";